export default __webpack_public_path__ + "static/media/EM0040.34I-19608_-25384_0.7d474688.jpg";